import styles2 from 'assets/scss/views/Auth2.scss'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { withLastLocation } from 'react-router-last-location'
import { compose } from 'recompose'
import { DisplayText, Image, PropertyBar, Spinner, TextContainer } from '../components'
import defaultPropertyImage from './../assets/images/defaultPropertyImage.png'

class AuthContent extends React.Component {
  static propTypes = {
    children: PropTypes.children,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    hasToken: PropTypes.bool,
    property: PropTypes.any,
    propertyFetching: PropTypes.bool,
    withSpacer: PropTypes.bool,
  }

  render() {
    const { title, subtitle, propertyFetching, property, hasToken, withSpacer = true } = this.props

    return (
      <Fragment>
        {(propertyFetching || hasToken) && <Spinner size="large" />}
        <div>
          {property && (
            <Fragment>
              {property.images && property.images[0] ? (
                <div className={styles2.MobileHeaderWithImage}>
                  <Image source={property.images[0]} className={styles2.PropertyBarMobileBackgroundImage} />
                  <div className={styles2.PropertyBarWrap}>
                    <PropertyBar property={property} />
                  </div>
                </div>
              ) : (
                <div className={styles2.MobileHeaderWithoutImage}>
                  <PropertyBar property={property} />
                </div>
              )}
            </Fragment>
          )}

          {!hasToken &&
            !propertyFetching && (
              <div className={styles2.VerticalAlign}>
                <div className={styles2.Auth}>
                  <div className={styles2.Text}>
                    <TextContainer>
                      <DisplayText size="large">{title}</DisplayText>
                      {subtitle && <p>{subtitle}</p>}
                    </TextContainer>

                    {withSpacer && <div className={styles2.Spacer} />}

                    <div>{this.props.children}</div>
                  </div>
                  <div className={styles2.Image}>
                    <Image
                      source={
                        property && property.images && property.images[0] ? property.images[0] : defaultPropertyImage
                      }
                      style={{
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                      }}
                    />

                    {property && (
                      <div className={styles2.PropertyBarWrap}>
                        <PropertyBar property={property} inline={true} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ FlowReducer }) => {
  const { fetching, property = {} } = FlowReducer
  return {
    property,
    propertyFetching: fetching,
  }
}

export default compose(
  translate('translations'),
  connect(mapStateToProps),
)(withLastLocation(AuthContent))



// WEBPACK FOOTER //
// ./src/views/AuthContent.js